import { profilesGenerated } from './generated/profiles';


export const profiles = profilesGenerated.enhanceEndpoints({});
